var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "design-system",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8L7.5 9.5L10.5 6.5M8 0.5C6.5 1.5 4.5 2.5 2.5 2.5C2.5 2.5 2.5 5 2.5 9C2.5 13 8 15.5 8 15.5C8 15.5 13.5 13 13.5 9C13.5 5 13.5 2.5 13.5 2.5C11.5 2.5 9.5 1.5 8 0.5Z",
    stroke: "#354764",
    strokeOpacity: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldChecked);
export default __webpack_public_path__ + "static/media/shield-checked.61a5752aa752ce59777d94981a31958a.svg";
export { ForwardRef as ReactComponent };